import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Loader from '../components/loader/Loader';

interface PrivateRouteProps {
  children?: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = () => {
  const location = useLocation();
  const auth = useAuth();

  if (auth.isLoading) {
    return <Loader />;
  }

  if (!auth.isAuthenticated) {
    if (location.pathname !== '/') {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;
